import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { FlexBox } from '../../pages/shared-components/flex-box';
import './StepRail.scss';
import { StepRailItem, StepRailStatus } from './types';

interface StepRailProps {
  steps: readonly StepRailItem[];
  currentStepId: string;
  resolveStatus: (stepId: string) => StepRailStatus;
  onSelectStep: (stepId: string) => void;
  resolveDescription?: (stepId: string) => string | undefined;
  children?: ReactNode;
}

const StepRailImpl: React.FC<StepRailProps> = (props) => {
  const {
    steps,
    currentStepId,
    resolveStatus,
    onSelectStep,
    resolveDescription,
    children,
  } = props;
  const handleSelectStep = (stepId: string): void => {
    if (stepId === currentStepId) {
      return;
    }

    onSelectStep(stepId);
  };

  return (
    <FlexBox
      direction='column'
      role='list'
      className='wizard'
    >
      {
        steps.map((step, index) => {
          const status = resolveStatus(step.id);
          const isCurrent = step.id === currentStepId;
          const isStepDisabled = status === 'disabled';
          const description = resolveDescription?.(step.id);

          return (
            <div
              key={step.id}
              role='listitem'
              className={`wizard-progress ${status}`}
            >
              <div className='wizard-progress__nav'>
                <button
                  type='button'
                  className={isStepDisabled ? 'disabled' : ''}
                  aria-current={isCurrent ? 'step' : undefined}
                  aria-disabled={isStepDisabled}
                  disabled={isStepDisabled}
                  onClick={() => handleSelectStep(step.id)}
                >
                  {step.title}
                  <span className='count-number'>{index + 1}</span>
                </button>
                {isCurrent && description && <Text block as='p'>{description}</Text>}
              </div>
              <section className='wizard-progress__section'>
                {isCurrent && children}
              </section>
            </div>
          );
        })
      }
    </FlexBox>
  );
};

export const StepRail = observer(StepRailImpl);
